
<div class="cta-bar" :class="['container', {'is-visible': visible }, {'is-sticky': sticky }]">
  <div class="prompt" :style="{backgroundImage: background ? 'url(' + background + ')' : null}">
    <div class="prompt__left">
      <p class="prompt__title">{{ name }}</p>
    </div>

    <div class="prompt__right"><slot></slot></div>
  </div>
</div>
